import { useRouter } from 'next/router';

export const useLocale = () => {
  const router = useRouter();
  const queryLocale = router.query.locale;

  return Array.isArray(queryLocale) ? queryLocale?.[0] : queryLocale || 'en';
};
